<h1 mat-dialog-title>{{ 'Confirmation' | translate }}</h1>
<div mat-dialog-content>
  <p>{{mensaje}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close()" class="deleteBtnLeft">{{ 'No' | translate }}</button>
  <button class="deleteBtn" mat-button (click)="confirmDelete()" cdkFocusInitial>{{ 'Yes' | translate }}</button>
</div>
